import { zonedInputToUtcIso } from "@/pages/Marketplace/shared/tzHelpers";

/** Convert a `datetime-local` value (venue wall-clock) to a UTC ISO string. */
export function toIso(datetimeLocal: string, tz: string): string {
  if (!datetimeLocal) return datetimeLocal;
  const withSeconds = datetimeLocal.length === 16 ? `${datetimeLocal}:00` : datetimeLocal;
  return zonedInputToUtcIso(withSeconds, tz);
}
